<template>
  <div id="business">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
import 'normalize.css'
import favicon from '../favicon.png'
export default {
  name: 'APP',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    if (window.location.host === 'ai-pilot.cc') {
      this.$store.dispatch('setLogoName', 'aiPilot')
      document.title = 'AiPilot'
      const iconLink = document.querySelector('link[rel="shortcut icon"]')
      iconLink.href = favicon
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<!--局部样式-->
<style lang="scss" scoped>
#business {
  // top: 48px;
  // position: relative;
}
</style>
<style lang="scss">
/*每个页面公共css */
</style>



// WEBPACK FOOTER //
// src/App.vue